var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgM11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1958 1.875V6.3C11.1958 6.63 10.8058 6.795 10.5658 6.5775L9.25328 5.37C9.11078 5.235 8.88578 5.235 8.74328 5.37L7.43078 6.57C7.19078 6.795 6.80078 6.6225 6.80078 6.3V1.875C6.80078 1.665 6.96578 1.5 7.17578 1.5H10.8208C11.0308 1.5 11.1958 1.665 11.1958 1.875Z",
    fill: "#0e131c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.735 1.54516C12.5175 1.51516 12.3225 1.70266 12.3225 1.92016V6.43516C12.3225 7.00516 11.985 7.52266 11.46 7.75516C10.935 7.98016 10.3275 7.88266 9.9075 7.49266L9.255 6.89266C9.1125 6.75766 8.895 6.75766 8.745 6.89266L8.0925 7.49266C7.8225 7.74766 7.47 7.87516 7.1175 7.87516C6.9225 7.87516 6.7275 7.83766 6.54 7.75516C6.015 7.52266 5.6775 7.00516 5.6775 6.43516V1.92016C5.6775 1.70266 5.4825 1.51516 5.265 1.54516C3.165 1.80766 2.25 3.22516 2.25 5.25016V12.7502C2.25 15.0002 3.375 16.5002 6 16.5002H12C14.625 16.5002 15.75 15.0002 15.75 12.7502V5.25016C15.75 3.22516 14.835 1.80766 12.735 1.54516ZM13.125 14.0627H6.75C6.4425 14.0627 6.1875 13.8077 6.1875 13.5002C6.1875 13.1927 6.4425 12.9377 6.75 12.9377H13.125C13.4325 12.9377 13.6875 13.1927 13.6875 13.5002C13.6875 13.8077 13.4325 14.0627 13.125 14.0627ZM13.125 11.0627H9.9375C9.63 11.0627 9.375 10.8077 9.375 10.5002C9.375 10.1927 9.63 9.93766 9.9375 9.93766H13.125C13.4325 9.93766 13.6875 10.1927 13.6875 10.5002C13.6875 10.8077 13.4325 11.0627 13.125 11.0627Z",
    fill: "#0e131c"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgM11);
export default __webpack_public_path__ + "static/media/m_11.ead0897a3b4ad99a95eb3da734be2763.svg";
export { ForwardRef as ReactComponent };